import styled from 'styled-components';

export const ContainerLink = styled.a<{
    fontColor?: string;
    fontSize?: string;
    fontWeight?: string;
    lineHeight?: string;
    textAlign?: string;
}>`
  font-weight: ${({ fontWeight }) => fontWeight ? fontWeight : '400' };
  font-size: ${({ fontSize }) => fontSize ? fontSize : '16px' };
  line-height: ${({ lineHeight }) => lineHeight ? lineHeight : '22px' };;
  color: ${({ fontColor }) => fontColor ? fontColor : '#000'};
  text-align: ${({ textAlign }) => textAlign ? textAlign : 'left'};
  cursor: pointer;
`
